import { flow, types } from "mobx-state-tree";
import { createData, fetchData, revokeData } from "@/core/api/apiKeys";

const $apiKeys = types
  .model("$apiKeys", {
    data: types.array(
      types.model("$apiKeys.item", {
        id: types.string,
        name: types.string,
        owner: types.string,
        createdAt: types.string,
        lastUsedAt: types.maybeNull(types.string),
        revokedAt: types.maybeNull(types.string),
      })
    ),
  })
  .actions((self) => ({
    fetchData: flow(function* () {
      const { data } = yield fetchData();
      self.setData(data);
    }),
    create: flow(function* (name) {
      // Владельца не передаём: сервер выпускает ключ только на учётку сессии.
      const { data } = yield createData({ name });

      // Токен снимается с записи до попадания в стор: он показывается один
      // раз в диалоге, и наблюдаемым данным делать с ним нечего.
      const { token, ...key } = data;
      self.data.push(key);
      return token;
    }),
    revoke: flow(function* (id) {
      const { data } = yield revokeData(id);
      self.setData(self.data.map((key) => (key.id === data.id ? data : key)));
    }),
    setData(data) {
      self.data = data;
    },
  }))
  .views((self) => ({
    get getData() {
      return self.data;
    },
  }))
  .create({ data: [] });

export default $apiKeys;
